
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 12 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.812 2.415a.234.234 0 00-.375.28c1.63 2.184 1.404 5.286-.526 7.216a5.538 5.538 0 01-7.822 0 5.537 5.537 0 010-7.822C4.02.156 7.125-.068 9.309 1.567a.234.234 0 00.281-.375 5.997 5.997 0 00-7.833.565A5.96 5.96 0 000 6c0 1.603.624 3.11 1.757 4.243A5.96 5.96 0 006 12c1.603 0 3.11-.624 4.243-1.757a5.997 5.997 0 00.57-7.828z"}}),_c('path',{attrs:{"d":"M10.245 1.76l-.004-.004a.234.234 0 00-.332.33l.004.005a.234.234 0 00.331 0 .234.234 0 00.001-.331zM6 1.078A4.927 4.927 0 001.078 6 4.927 4.927 0 006 10.922 4.927 4.927 0 0010.922 6 4.927 4.927 0 006 1.078zm0 9.375A4.458 4.458 0 011.547 6 4.458 4.458 0 016 1.547 4.458 4.458 0 0110.453 6 4.458 4.458 0 016 10.453z"}}),_c('path',{attrs:{"d":"M6 5.227a.768.768 0 00-.355.086L3.697 3.365a.234.234 0 00-.331.332l1.947 1.948a.775.775 0 00.454 1.093v1.197a.234.234 0 00.47 0V6.736A.775.775 0 006 5.226zm0 1.078a.305.305 0 110-.61.305.305 0 010 .61zm3.844-.535H9.51a.234.234 0 000 .469h.333a.234.234 0 100-.469zM2.49 5.761h-.334a.234.234 0 100 .469h.333a.234.234 0 100-.469zm3.514-3.839a.234.234 0 00-.234.234v.333a.234.234 0 00.469 0v-.333a.234.234 0 00-.235-.234zm-.008 7.354a.234.234 0 00-.235.235v.333a.234.234 0 00.469 0V9.51a.234.234 0 00-.234-.235zM2.714 7.03l-.001-.003a.234.234 0 00-.294-.152.235.235 0 00-.153.294l.001.003a.233.233 0 00.294.152.235.235 0 00.153-.295zm1.928 2.135a3.476 3.476 0 01-1.61-1.42.234.234 0 10-.404.238 3.949 3.949 0 001.828 1.612.234.234 0 00.308-.123.234.234 0 00-.122-.307z"}})])
          )
        }
      }
    